import locale from '@glu/locale';

locale.set({
  selectAll: 'Select all'
});
